import { getLocalizedString, isDefined } from "@grandvisionhq/utils";
import { mapServerToVariantBase } from "./map-server-to-variant-base.js";
import { getContactLensProductFeatures } from "../../../../utils/product-feature-mappers/mappers/server-to-client/utils/product-feature-mappers/get-contact-lens-product-features.js";
import { getCLMetaTitle } from "../../../../utils/mappers/server-to-client/utils/get-product-seo-info.js";
import { mapServerToContactLensesSpecifications } from "../../../../specification-mappers/mappers/server-to-client/specification-mappers/map-server-to-contact-lenses-specifications.js";
import { mapToPrescriptionRanges } from "../../../../utils/mappers/server-to-client/utils/map-to-prescription-ranges.js";
const mapServerToContactLensVariant = (serverProduct, slug, locale, priceSegmentChannelKey) => {
  const { variants: serverVariants } = serverProduct;
  if (!serverVariants || !serverVariants.length) {
    return;
  }
  const clientVariants = serverVariants.map((serverVariant) => {
    const variantBase = mapServerToVariantBase(
      serverVariant,
      serverProduct,
      slug,
      locale,
      priceSegmentChannelKey
    );
    if (!variantBase) return;
    const { variantTypeDetails } = serverVariant;
    const { color, opticalRanges, subscriptionIntervals } = variantTypeDetails;
    const { brand } = serverProduct;
    const { replacementFrequencyAllLocales } = serverProduct.productTypeDetails;
    const colorDisplayName = Array.isArray(color) ? color.join(" / ") : color;
    const lensesPerBox = variantTypeDetails.packageQuantity;
    const productFeatures = getContactLensProductFeatures(variantTypeDetails);
    const replacementFrequency = getLocalizedString(replacementFrequencyAllLocales, locale);
    const metaTitle = getCLMetaTitle(serverVariant, serverProduct, replacementFrequency);
    const specifications = mapServerToContactLensesSpecifications(
      serverVariant,
      brand,
      replacementFrequency,
      replacementFrequencyAllLocales
    );
    const prescriptionRanges = mapToPrescriptionRanges(opticalRanges);
    const isPublished = serverProduct.isPublished && variantBase.isPublished;
    if (isPublished && (!prescriptionRanges || !prescriptionRanges.length)) {
      console.error(
        `Required prescription ranges not provided for Contact Lens. slug: ${slug}, sku: ${variantBase.sku}`
      );
    }
    if (isPublished && !!prescriptionRanges?.length && !prescriptionRanges.some((attr) => attr.name === "power")) {
      console.error(
        `Required Power prescription range not provided for Contact Lens. slug: ${slug}, sku: ${variantBase.sku}`
      );
    }
    const clientVariant = {
      ...variantBase,
      variantType: "contact-lens",
      prescriptionRanges,
      isMasterProduct: variantTypeDetails.isMaster,
      masterVariantSku: variantTypeDetails.masterVariantSku,
      lensesPerBox,
      lensType: variantTypeDetails.lensType ?? void 0,
      replacementFrequency,
      facets: {
        color: !!colorDisplayName ? colorDisplayName : void 0,
        lensesPerBox: String(lensesPerBox)
      },
      specifications,
      productFeatures,
      seoConfig: {
        ...variantBase.seoConfig,
        metaTitle
      },
      availableSubscriptionIntervals: subscriptionIntervals,
      maxQuantityPerVariant: variantTypeDetails.maxQuantityPerVariant ?? void 0
    };
    return clientVariant;
  });
  return clientVariants.filter(isDefined);
};
export {
  mapServerToContactLensVariant
};
//# sourceMappingURL=map-server-to-contact-lens-variant.js.map
